import React, {memo, useState, useEffect} from "../../../../__snowpack__/pkg/react.js";
import {Table, Form, Button, Space, Row, TreeSelect, Select} from "../../../../__snowpack__/pkg/antd.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
import qs from "../../../../__snowpack__/pkg/query-string.js";
import {ScrollTopButton} from "../../../components/ScrollTopButton.js";
import {PopoverImg} from "../../../components/PopoverImg/index.js";
import FixedBottomBar from "../../../components/ProductDetailCommon/FixedBottomBar/index.js";
import EllipsisTooltip from "../../../components/ProductDetailCommon/EllipsisTooltip/index.js";
import {useHistory} from "../../../../__snowpack__/pkg/react-router-dom.js";
import Alert from "../../../components/GnAlert/index.js";
import replaceIcon from "../../../assets/replace.svg";
import noProductIcon from "../../../assets/no-product-icon.png";
import {axios} from "../../../lib/axios.js";
import {useUpdateRoute} from "../../../lib/useIframe.js";
import {handleError} from "../../../lib/errorHandler.js";
import {useShopChange} from "../detail/store.js";
const {Column} = Table;
const {Option} = Select;
export const filterCategoryData = (categoryData = []) => {
  const mapData = (array) => {
    return array.map((item) => {
      if (item?.children) {
        return {
          ...item,
          children: mapData(item?.children),
          title: item?.name,
          value: item?.id,
          key: item?.id
        };
      } else {
        return {
          ...item,
          title: item?.name,
          value: item?.id,
          key: item?.id
        };
      }
    });
  };
  return mapData(categoryData || []);
};
const MassEditCategory = memo((props) => {
  const {formatMessage} = useIntl();
  const [form] = Form.useForm();
  const {goBack} = useHistory();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categoryMapData, setCategoryMapData] = useState({});
  const [taxMapData, setTaxMapData] = useState({});
  const [tagMapData, setTagMapData] = useState({});
  const {getShopIdCategoryData, getTagData, getTaxClassData} = useShopChange();
  let productList = JSON.parse(localStorage.getItem("wooProductList") || "[]");
  const productIds = productList?.map((item) => item?.id);
  const queries = qs.parse(location.search);
  const {updateRoute} = useUpdateRoute();
  const pageInit = async () => {
    try {
      if (productList?.length) {
        const {data = []} = await axios.post("/saas/product/v2/get-product-list", {
          channel: "WOO_COMMERCE_ID",
          productIds
        });
        setTableData(data);
        const cacheTagMapData = {};
        const cacheTaxMapData = {};
        const cacheCategoryMapData = {};
        await Promise.all(data.map(async (item) => {
          const shopId = item?.woocommerceProductVO?.shopId;
          const categoryData = await getShopIdCategoryData({
            channelId: "WOO_COMMERCE_ID",
            shopId: shopId || ""
          });
          const tagData = await getTagData({
            shopId: shopId || "",
            channelId: "WOO_COMMERCE_ID",
            dataType: "PRODUCT_TAG"
          });
          const taxData = await getTaxClassData({
            shopId: shopId || "",
            channelId: "WOO_COMMERCE_ID",
            dataType: "TAX_CLASSES"
          });
          cacheCategoryMapData[shopId] = categoryData;
          cacheTagMapData[shopId] = tagData;
          cacheTaxMapData[shopId] = taxData;
        }));
        setCategoryMapData(cacheCategoryMapData);
        setTaxMapData(cacheTaxMapData);
        setTagMapData(cacheTagMapData);
      }
    } catch (error) {
      handleError(error);
    }
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields() || {};
      const {categoryIds = {}, tagIds = {}, taxClass = {}, taxStatus = {}} = values;
      const submitData = tableData.map((item) => {
        const {id, woocommerceProductVO} = item;
        const {shopId} = woocommerceProductVO || {};
        const activeCategory = categoryIds[id] || [];
        const activeTagIds = tagIds[id] || [];
        const activeTaxClass = taxClass[id];
        const activeTaxStatus = taxStatus[id];
        return {
          ...item,
          productId: id,
          categoryId: activeCategory.map((item2) => item2?.value)?.join(","),
          shopId,
          operateType: "edit",
          woocommerceProductAttributesDTO: {
            tags: activeTagIds.map((item2) => {
              return {
                id: item2?.value,
                name: item2?.label
              };
            }),
            taxStatus: activeTaxStatus,
            taxClass: activeTaxClass
          }
        };
      });
      axios.post("/saas/product/v1/products/_save_category_attributes", submitData).then(() => {
        updateRoute(`product-woo-commerce/mass-edit?&status=${queries?.status || "DRAFT"}`);
      }).catch((error) => {
        handleError(error);
      });
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    pageInit();
  }, []);
  const showMassEdit = () => {
  };
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Alert, {
    closable: true,
    showIcon: true,
    message: formatMessage({
      id: "massEditTip1"
    })
  }), /* @__PURE__ */ React.createElement(Form, {
    form
  }, /* @__PURE__ */ React.createElement(Table, {
    loading,
    dataSource: tableData,
    rowKey: "variationId",
    scroll: {x: 1080},
    sticky: {
      offsetHeader: 48
    },
    pagination: false
  }, /* @__PURE__ */ React.createElement(Column, {
    width: 440,
    title: formatMessage({id: "productInfoSource"}),
    render: (text, record) => {
      const {images = [], sourceCategoryName, productName, shopName} = record || {};
      return /* @__PURE__ */ React.createElement("div", {
        className: "productInfo"
      }, /* @__PURE__ */ React.createElement(PopoverImg, {
        avatarSize: 86,
        previewImage: images[0] || noProductIcon
      }), /* @__PURE__ */ React.createElement("div", {
        className: "productInfoText"
      }, /* @__PURE__ */ React.createElement("div", null, sourceCategoryName || formatMessage({id: "categoryNo"})), /* @__PURE__ */ React.createElement(EllipsisTooltip, {
        title: productName
      }), /* @__PURE__ */ React.createElement("div", null, shopName)));
    }
  }), /* @__PURE__ */ React.createElement(Column, {
    width: 220,
    render: (text, record) => {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("img", {
        style: {marginTop: 4},
        src: replaceIcon
      }));
    }
  }), /* @__PURE__ */ React.createElement(Column, {
    title: /* @__PURE__ */ React.createElement(Row, {
      align: "middle"
    }, /* @__PURE__ */ React.createElement("span", null, formatMessage({id: "channelCategoryAttributes"}, {channelName: "WooCommerce"}))),
    render: (text, record) => {
      const {
        id,
        woocommerceProductVO: {shopId}
      } = record;
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Form.Item, {
        label: formatMessage({id: "category"}),
        name: ["categoryIds", id],
        rules: [
          {
            required: true,
            message: formatMessage({id: "selectCategories"})
          }
        ]
      }, /* @__PURE__ */ React.createElement(TreeSelect, {
        placeholder: formatMessage({id: "pleaseChoose"}),
        className: "w300",
        filterTreeNode: true,
        treeDefaultExpandAll: true,
        treeData: filterCategoryData(categoryMapData[shopId] || []),
        treeCheckable: true,
        treeCheckStrictly: true,
        showCheckedStrategy: "SHOW_ALL",
        showArrow: true
      })), /* @__PURE__ */ React.createElement(Form.Item, {
        label: formatMessage({id: "productTag"}),
        name: ["tagIds", id]
      }, /* @__PURE__ */ React.createElement(Select, {
        className: "w300",
        labelInValue: true,
        mode: "multiple",
        allowClear: true
      }, tagMapData[shopId]?.length && tagMapData[shopId].map((item) => {
        return /* @__PURE__ */ React.createElement(Option, {
          value: item.id,
          key: item.id,
          title: item.name
        }, item.name);
      }))), /* @__PURE__ */ React.createElement(Form.Item, {
        name: ["taxStatus", id],
        label: formatMessage({id: "taxStatus"}),
        initialValue: "taxable"
      }, /* @__PURE__ */ React.createElement(Select, {
        className: "w200"
      }, /* @__PURE__ */ React.createElement(Option, {
        value: "taxable"
      }, "Taxable"), /* @__PURE__ */ React.createElement(Option, {
        value: "shipping"
      }, "Shipping only"), /* @__PURE__ */ React.createElement(Option, {
        value: "none"
      }, "None"))), /* @__PURE__ */ React.createElement(Form.Item, {
        name: ["taxClass", id],
        label: formatMessage({id: "taxClass"})
      }, /* @__PURE__ */ React.createElement(Select, {
        className: "w200"
      }, taxMapData[shopId]?.length && taxMapData[shopId].map((item) => {
        return /* @__PURE__ */ React.createElement(Option, {
          key: item?.slug,
          value: item?.slug
        }, item?.name);
      }))));
    }
  }))), /* @__PURE__ */ React.createElement(ScrollTopButton, null), /* @__PURE__ */ React.createElement(FixedBottomBar, null, /* @__PURE__ */ React.createElement(Row, {
    justify: "center"
  }, /* @__PURE__ */ React.createElement(Space, {
    align: "center"
  }, /* @__PURE__ */ React.createElement(Button, {
    onClick: goBack
  }, formatMessage({id: "cancel"})), /* @__PURE__ */ React.createElement(Button, {
    disabled: tableData?.length == 0,
    loading,
    onClick: handleSubmit,
    type: "primary"
  }, formatMessage({id: "saveUpdateAndNextStep"}))))));
});
const Wrapper = styled.div`
  .productInfo {
    display: flex;
    align-items: flex-start;
    &Text {
      flex: 1;
      margin-left: 6px;
    }
  }
  .ant-table-cell {
    vertical-align: top;
  }
  .ant-select-selection-overflow {
    position: relative;
    display: flex;
    flex: auto;
    flex-wrap: wrap;
    max-width: 100%;
    .ant-select-selection-overflow-item {
      flex: none;
      align-self: center;
      max-width: 100%;
    }
  }
  .w200 {
    width: 200px;
  }
  .w300 {
    width: 300px;
  }
`;
export default MassEditCategory;
